// extracted by mini-css-extract-plugin
module.exports = {"root":"why-free_root__2yAVU","outer":"why-free_outer__FJ8hT","inner":"why-free_inner__2WA3F"};